import { render, staticRenderFns } from "./BoostPlanSetup.vue?vue&type=template&id=1ccefc19&scoped=true"
import script from "./BoostPlanSetup.vue?vue&type=script&lang=js"
export * from "./BoostPlanSetup.vue?vue&type=script&lang=js"
import style0 from "./BoostPlanSetup.vue?vue&type=style&index=0&id=1ccefc19&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ccefc19",
  null
  
)

export default component.exports